export const useCarbonEmissionQueryState = () => {
  const indexStore = useSearchResultIndexStore();

  const { asyncStatus, status } = useQueryState(() => ['carbon-emission', indexStore.offerUuidsMissingCarbon]);

  // Gate on offerUuidsMissingCarbon.length (the CO₂ equivalent of `active` in useSearchResultsQueryState)
  // so the skeleton only shows while offers actually await CO₂. The pending+loading union covers SSR /
  // pre-mount (query not fired yet = 'pending'), so it shows on the server until the async fetch fills values.
  const loading = computed(
    () =>
      indexStore.offerUuidsMissingCarbon.length > 0 && (status.value === 'pending' || asyncStatus.value === 'loading'),
  );

  return { loading };
};
